export const isOfTypeByProperty = <T>(
  obj: unknown,
  ...requiredProperty: (keyof T)[]
): obj is T => {
  return requiredProperty.every(property =>
    Object.prototype.hasOwnProperty.call(obj, property)
  );
};
